import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useCurrentShopConfigQuery = createQueryHook(ShopsApiClient.getCurrentShopConfig, {
  queryKey: ['currentShopConfig'],
})
